// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ReportVariantModal = t.struct({
    isOpen: t.Boolean,
    isSelected: t.Boolean,
    layoutName: t.String
}, 'ReportVariantModal');

export const getDefaultState = () =>
    new ReportVariantModal({
        isOpen: false,
        isSelected: false,
        layoutName: ''
    });

export default ReportVariantModal;



// WEBPACK FOOTER //
// ./src/reports/shared/state/report-variant-modal.js